// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3iVOj4QqBNFM61ukWpIuaX","Footer":"_3E19RU95m80cC1XoJfu9YX","MenuItem":"_2ARdJf-w-5ZzN9xYXK1PnN","Header":"mloB2F7JkCS3ZFlQa6TrV","Title":"_2FX3UpTbJGYFvCw3CYr5Hg","TableWrap":"hNLyJBCPvkEV0M5UY-Xo8","MainColumn":"_3Y93Sx67zNQ5RLjqbfGy_m","SideColumn":"_20PZG52VFueBbaM_SClh1Q","StackOnMobile":"_37Ly6LrZMsb8BzxVCqGuXo","container-fluid":"_6yf9xVyY3XTpnyequG_Ct"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Metal/ContractPca/styles.module.css
// module id = 630
// module chunks = 0